import axios from "axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { ApplicationAttributeState, ApplicationAttributeItem } from './types';


export const actions: ActionTree<ApplicationAttributeState, RootState> = {
  async getApplicationAttributes({commit}, data: {applicationId: number}) {
    try {
      const resp = await axios({
        url: '/lk-api/distribution/push/attribute',
        params: data,
      });
      commit("setApplicationAttributes", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getApplicationAttributeItem({commit}, data: {id: number, application_id: number}){
    try {
      const resp = await axios({
        url: `push/applications/${data.application_id}/attributes/${data.id}`
      })
      const attribute = resp.data;
      attribute.id = data.id;
      commit(`setApplicationAttributeItem`, attribute);
      return attribute;
    } catch (err) {
      throw err;
    }
  },
  async saveApplicationAttribute({commit, dispatch}, data: {item: ApplicationAttributeItem, application_id: number}) {
    try {
      const resp = await axios({
        method: data.item.id ? 'put' : 'post',
        url: `/push/applications/${data.application_id}/attributes/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getApplicationAttributes',{application_id: data.application_id});
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async deleteApplicationAttribute({commit, dispatch}, data: {item: ApplicationAttributeItem, application_id: number}) {
    try {
      const resp = await axios({
        method: 'delete',
        url: `/push/applications/${data.application_id}/attributes/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getApplicationAttributes',{application_id: data.application_id});
      return resp;
    } catch (err) {
      throw err;
    }
  },
}